import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumb = ({ 
  items = [], 
  showHome = true,
  className = '' 
}) => {
  if (!items?.length && !showHome) return null;

  const breadcrumbItems = showHome 
    ? [{ label: 'Home', path: '/homepage', icon: 'Home' }, ...items]
    : items;

  return (
    <nav className={`flex items-center space-x-1 text-sm font-body ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {breadcrumbItems?.map((item, index) => {
          const isLast = index === breadcrumbItems?.length - 1;
          const isFirst = index === 0;

          return (
            <li key={index} className="flex items-center">
              {/* Separator */}
              {!isFirst && (
                <Icon 
                  name="ChevronRight" 
                  size={14} 
                  className="text-muted-foreground mx-1" 
                />
              )}
              {/* Breadcrumb Item */}
              {isLast ? (
                <span className="flex items-center space-x-1 text-foreground font-medium">
                  {item?.icon && (
                    <Icon name={item?.icon} size={14} />
                  )}
                  <span>{item?.label}</span>
                </span>
              ) : (
                <Link
                  to={item?.path}
                  className="flex items-center space-x-1 text-muted-foreground hover:text-foreground transition-micro"
                >
                  {item?.icon && (
                    <Icon name={item?.icon} size={14} />
                  )}
                  <span>{item?.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default NavigationBreadcrumb;